import { createCRUDHook } from './createCRUDHook';
import { HardwareTypeDto } from 'utils/models';
import { TBL_HARDWARE_TYPE } from './apiEndPoints';

const { Context, useManager, useConsumer } = createCRUDHook<HardwareTypeDto>({
  entityName: 'HardwareType',
  endpoint: TBL_HARDWARE_TYPE,
});

export const HardwareTypeContext = Context;
export const useHardwareTypeManager = useManager;
export const useHardwareType = useConsumer;
